import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RecordingState } from '../../types';
import { submitRecitation } from './evaluationSlice';

interface RecitationState {
  recordingState: RecordingState;
  audioBlob: Blob | null;
  audioBlobUrl: string | null;
  inputLevel: number;
  error: string | null;
}

const initialState: RecitationState = {
  recordingState: 'idle',
  audioBlob: null,
  audioBlobUrl: null,
  inputLevel: 0,
  error: null,
};

const recitationSlice = createSlice({
  name: 'recitation',
  initialState,
  reducers: {
    setRecordingState(state, action: PayloadAction<RecordingState>) {
      state.recordingState = action.payload;
    },
    setAudioBlob(state, action: PayloadAction<{ blob: Blob; url: string }>) {
      state.audioBlob = action.payload.blob;
      state.audioBlobUrl = action.payload.url;
    },
    setInputLevel(state, action: PayloadAction<number>) {
      state.inputLevel = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.recordingState = 'error';
      state.error = action.payload;
    },
    reset(state) {
      if (state.audioBlobUrl) {
        URL.revokeObjectURL(state.audioBlobUrl);
      }
      state.recordingState = 'idle';
      state.audioBlob = null;
      state.audioBlobUrl = null;
      state.inputLevel = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitRecitation.fulfilled, (state) => {
        state.recordingState = 'idle';
      })
      .addCase(submitRecitation.rejected, (state) => {
        state.recordingState = 'idle';
      });
  },
});

export const { setRecordingState, setAudioBlob, setInputLevel, setError, reset } =
  recitationSlice.actions;
export default recitationSlice.reducer;
